import React, { useEffect, useState, useCallback } from "react";
import Index from "../../../Index";
import PagesIndex from "../../../PagesIndex";

const ViewScheduleInventory = () => {
  const params = PagesIndex.useParams();
  const { id } = params;
  const location = PagesIndex.useLocation();
  const { state } = location;
  const [scheduleData, setScheduleData] = useState([]);
  const [openCalenderStart, setOpenCalenderStart] = useState(false);
  const [openCalenderEnd, setOpenCalenderEnd] = useState(false);
  // const [currentPage, setCurrentPage] = useState(1);
  const [startDate, setStartDate] = useState(
    PagesIndex.dayjs().startOf("year")
  );
  const [endDate, setEndDate] = useState(PagesIndex.dayjs().endOf("year"));
  const handleGetScheduleData = useCallback(() => {
    const urlEncoded = new URLSearchParams();
    urlEncoded.append(
      "startDate",
      PagesIndex.moment(new Date(startDate)).format("YYYY-MM-DD")
    );
    urlEncoded.append(
      "endDate",
      PagesIndex.moment(new Date(endDate)).format("YYYY-MM-DD")
    );
    PagesIndex.apiPostHandler(
      PagesIndex.Api.GET_SCHEDULE_INVENTORY,
      urlEncoded
    ).then((res) => {
      if (res?.status === 200) {
        setScheduleData(res?.data);
      }
    });
  }, [startDate, endDate, id]);

  useEffect(() => {
    handleGetScheduleData();
  }, [handleGetScheduleData]);
  useEffect(() => {
    handleGetScheduleData();
  }, [handleGetScheduleData]);

  const handleDateChangeStart = useCallback((date) => {
    setStartDate(PagesIndex.dayjs(new Date(date)));
    setEndDate(PagesIndex.dayjs(new Date(date)));
  }, []);
  const handleDateChangeEnd = useCallback((date) => {
    setEndDate(PagesIndex.dayjs(new Date(date)));
  }, []);

  const handleDatePickerOpenStart = () => {
    setOpenCalenderStart(true);
  };

  const handleDatePickerCloseStart = useCallback(() => {
    setOpenCalenderStart(false);
  }, []);
  const handleDatePickerOpenEnd = () => {
    setOpenCalenderEnd(true);
  };

  const handleDatePickerCloseEnd = useCallback(() => {
    setOpenCalenderEnd(false);
  }, []);
  return (
    <Index.Box className="admin-dashboard-content admin-user-list-content">
      <Index.Box className="admin-user-list-flex admin-page-title-main">
        <Index.Typography
          className="admin-page-title admin-user-list-page-title"
          component="h2"
          variant="h2"
        >
          Inventory
        </Index.Typography>
        <Index.Box className="admin-userlist-inner-btn-flex">
          <Index.Box className="admin-modal-input-box admin-date-input-main">
            <Index.Box className="admin-form-group">
              <PagesIndex.LocalizationProvider dateAdapter={Index.AdapterDayjs}>
                <PagesIndex.DatePicker
                  open={openCalenderStart}
                  onClose={handleDatePickerCloseStart}
                  className="admin-form-control admin-date-picker-control"
                  value={startDate}
                  minDate={PagesIndex.dayjs().startOf("year")}
                  maxDate={PagesIndex.dayjs().endOf("year")}
                  onChange={handleDateChangeStart}
                  slotProps={{
                    popper: {
                      className: "date-picker-body",
                    },
                    textField: {
                      readOnly: true,
                      onClick: handleDatePickerOpenStart,
                    },
                    inputAdornment: {
                      onClick: handleDatePickerOpenStart, // This triggers on the calendar icon
                    },
                  }}
                  format="DD/MM/YYYY"
                />
              </PagesIndex.LocalizationProvider>
            </Index.Box>
          </Index.Box>
          <Index.Box className="admin-modal-input-box admin-date-input-main">
            <Index.Box className="admin-form-group">
              <PagesIndex.LocalizationProvider dateAdapter={Index.AdapterDayjs}>
                <PagesIndex.DatePicker
                  open={openCalenderEnd}
                  onClose={handleDatePickerCloseEnd}
                  className="admin-form-control admin-date-picker-control"
                  value={endDate}
                  minDate={PagesIndex.dayjs(startDate)}
                  maxDate={PagesIndex.dayjs().endOf("year")}
                  onChange={handleDateChangeEnd}
                  slotProps={{
                    popper: {
                      className: "date-picker-body",
                    },
                    textField: {
                      readOnly: true,
                      onClick: handleDatePickerOpenEnd,
                    },
                    inputAdornment: {
                      onClick: handleDatePickerOpenEnd, // This triggers on the calendar icon
                    },
                  }}
                  format="DD/MM/YYYY"
                />
              </PagesIndex.LocalizationProvider>
            </Index.Box>
          </Index.Box>
        </Index.Box>
      </Index.Box>
      <Index.Box className="common-card">
        <Index.Box className="page-table-main add-schedule-table-main">
          <Index.TableContainer
            component={Index.Paper}
            className="table-container"
          >
            <Index.Table aria-label="simple table" className="table">
              <Index.TableHead className="table-head">
                <Index.TableRow className="table-row">
                  <Index.TableCell
                    component="th"
                    variant="th"
                    className="table-th"
                    // width="10%"
                  >
                    Date
                  </Index.TableCell>
                  <Index.TableCell
                    component="th"
                    variant="th"
                    className="table-th"
                    // width="10%"
                  >
                    Scheduled Seconds
                  </Index.TableCell>
                  <Index.TableCell
                    component="th"
                    variant="th"
                    className="table-th"
                    // width="10%"
                  >
                    Total Seconds
                  </Index.TableCell>
                </Index.TableRow>
              </Index.TableHead>
              <Index.TableBody className="table-body">
                {scheduleData?.length ? (
                  scheduleData?.map((data) => {
                    return (
                      <Index.TableRow
                        sx={{
                          "&:last-child td, &:last-child th": {
                            border: 0,
                          },
                        }}
                        key={data?._id}
                      >
                        <Index.TableCell
                          component="td"
                          variant="td"
                          className="table-td"
                        >
                          <Index.Typography className="admin-table-data-text">
                            {" "}
                            <span className="news-id-text">{data?.date}</span>
                          </Index.Typography>
                        </Index.TableCell>
                        <Index.TableCell
                          component="td"
                          variant="td"
                          className="table-td"
                        >
                          <Index.Typography className="admin-table-data-text">
                            {data?.usedDuration}
                          </Index.Typography>
                        </Index.TableCell>
                        <Index.TableCell
                          component="td"
                          variant="td"
                          className="table-td"
                        >
                          <Index.Typography className="admin-table-data-text">
                            {data?.totalDuration}
                          </Index.Typography>
                        </Index.TableCell>
                      </Index.TableRow>
                    );
                  })
                ) : (
                  <PagesIndex.DataNotFound />
                )}
              </Index.TableBody>
            </Index.Table>
          </Index.TableContainer>
        </Index.Box>
      </Index.Box>
    </Index.Box>
  );
};
export default React.memo(ViewScheduleInventory);
